import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import VideoContent from "../QuestionTypesUpdate/VideoContent";
import TrueFalse from "../QuestionTypesUpdate/TrueFalse";
import Choice from "../QuestionTypesUpdate/Choice";
import Match from "../QuestionTypesUpdate/Match";
import Write from "../QuestionTypesUpdate/Write";
import Sentence from "../QuestionTypesUpdate/Sentence";
import Link from "../QuestionTypesUpdate/Link";

import RealMatch from "../QuestionTypesUpdate/RealMatch";
export const AdminUpdateQuestionDetail = () => {
    const params = useParams()

    return (
        <div>
            { }
            {
                (() => {
                    //video
                    if (params["questiontype"] === "1") {
                        return (
                            <VideoContent />
                        )
                    }
                    //choice
                    else if (params["questiontype"] === "2") {
                        return (
                            <Choice />
                        )
                    }
                    //match
                    else if (params["questiontype"] === "3") {
                        return (
                            <Match />
                        )
                    }
                    //YAZMA
                    else if (params["questiontype"] === "4") {
                        return (
                            <Write />
                        )
                    }
                    //TRUE FALSE
                    else if (params["questiontype"] === "5") {
                        return (
                            <TrueFalse />
                        )
                    }
                    //realmatch
                    else if (params["questiontype"] === "6") {
                        return (
                            <RealMatch />
                        )
                    }
                    //sentence
                    else if (params["questiontype"] === "7") {
                        return (
                            <Sentence />
                        )
                    }
                    else if (params["questiontype"] === "8") {
                        return (
                            <Link />
                        )
                    }
                    else {
                        return (
                            <p>Hatalı Tür Seçimi</p>
                        )
                    }
                })()
            }

        </div>
    )
}
export default AdminUpdateQuestionDetail;
